/* Nightpass - partage de panier.

   Shopify sait recreer un panier a partir d'une URL de la forme
   /cart/{variant_id}:{quantite},{variant_id}:{quantite}.

   COPIE SEULE, PAS DE FEUILLE DE PARTAGE SYSTEME

   navigator.share a ete retire volontairement : sur iOS et Android il ouvre
   la feuille de partage du systeme, un panneau plein ecran qu'il faut refermer
   pour un geste qui devait etre instantane. Le lien va donc toujours dans le
   presse-papier, sur tous les appareils - un seul comportement a expliquer,
   un seul a tester.

   Le lien est prepare a l'avance et tenu a jour, pas construit au clic. Deux
   raisons :

   1. navigator.clipboard.writeText doit etre appele dans la foulee du geste
      utilisateur. En passant d'abord par un fetch, on sortait de cette fenetre
      et le navigateur finissait par refuser la copie - visible en cliquant
      plusieurs fois de suite.
   2. Sans attente reseau, plus besoin d'etat "Preparation" : la copie est
      instantanee.

   Ce que le lien NE transporte PAS : les codes de reduction, la note de
   commande et les proprietes de ligne. Les quantites sont replafonnees par
   Shopify si le stock a baisse entre-temps. */

(function () {
  if (window.__npShareReady) return;
  window.__npShareReady = true;

  /* Duree du temoin « Lien copie » sur le bouton. */
  var TEMOIN = 5000;

  var cached = null;
  var refreshTimer = null;

  function say(note, msg, state) {
    if (!note) return;
    note.textContent = msg;
    note.setAttribute('data-state', state || '');
    /* Le succes se lit sur le bouton : la zone de message n'est gardee que
       pour les lecteurs d'ecran, que la bascule de libelle n'annonce pas. */
    if (state === 'ok') {
      note.setAttribute('data-discret', '');
    } else {
      note.removeAttribute('data-discret');
    }
    note.hidden = false;
  }

  /* Le message appartient au bloc qu'on vient de cliquer. Depuis que la page
     panier porte DEUX boutons - un dans l'en-tete, un sous les moyens de
     paiement - un `document.querySelector` global affichait toujours la
     reponse a cote du premier, donc hors ecran pour qui cliquait le second. */
  function noteDe(btn) {
    var bloc = btn.closest ? btn.closest('.np-share') : null;
    return (bloc || document).querySelector('[data-np-share-note]');
  }

  /* Bascule le bouton en « Lien copie » puis le rend a son etat normal.
     Le minuteur est porte par le bouton lui-meme : deux clics rapproches
     reconduisent le temoin au lieu de le couper au milieu, et chacun des deux
     boutons de la page garde le sien. */
  function temoigner(btn) {
    if (!btn) return;
    if (btn.__npTemoin) clearTimeout(btn.__npTemoin);
    btn.setAttribute('data-copie', '');
    btn.__npTemoin = setTimeout(function () {
      btn.removeAttribute('data-copie');
      btn.__npTemoin = null;
    }, TEMOIN);
  }

  /* `?storefront=true` : sans lui, un permalien de panier envoie le
     destinataire DIRECTEMENT au paiement. Recevoir un lien qui ouvre un
     formulaire de carte bancaire est brutal - et surtout, on veut qu'il puisse
     regarder ce qu'on lui a compose, ajuster les quantites, retirer une ligne.
     Avec le parametre, Shopify remplit le panier puis redirige vers /cart. */
  function buildUrl(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var parts = cart.items.map(function (i) {
      return i.variant_id + ':' + i.quantity;
    });
    return window.location.origin + '/cart/' + parts.join(',') + '?storefront=true';
  }

  function refresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { cached = buildUrl(cart); })
        .catch(function () {});
    }, delay || 0);
  }

  /* Repli synchrone : reste autorise quand l'API presse-papier est refusee. */
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function copy(url, btn) {
    var note = noteDe(btn);
    function ok() { temoigner(btn); say(note, 'Lien de ton panier copié', 'ok'); }
    function fail() { say(note, 'Copie impossible, réessaie dans un instant.', 'err'); }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(ok).catch(function () {
        if (legacyCopy(url)) { ok(); } else { fail(); }
      });
    } else if (legacyCopy(url)) {
      ok();
    } else {
      fail();
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-np-share]');
    if (!btn) return;

    if (cached) { copy(cached, btn); return; }

    /* Cas rare : clic avant que le lien soit pret. On le fabrique alors a la
       volee, quitte a perdre le geste utilisateur pour la copie. */
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cached = buildUrl(cart);
        if (!cached) {
          say(noteDe(btn), 'Ton panier est vide, il n\'y a rien à partager.', 'err');
          return;
        }
        copy(cached, btn);
      })
      .catch(function () {
        say(noteDe(btn), 'Impossible de préparer le lien pour le moment.', 'err');
      });
  });

  /* Maintien a jour du lien : le panier bouge sans rechargement de page. */
  function boot() {
    try {
      if (typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(0); });
      }
    } catch (err) {}

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) refresh(700);
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('cart-remove-button, .quantity__button')) refresh(700);
    });

    refresh(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
